// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7d43f817","488":"a136b108","977":"0f72275d"}[chunkId] + ".chunk.js";
};